export default function reducer(
  state = {
    status: '',
    error: null,
    actives: {
      byid: {},
      list: []
    }
  },
  action
) {
  let data;
  switch (action.type) {
    case 'CLEAR_STORE':
      state = defaultState();
      break;
    case 'TRACKERS_ACTIVES_INIT':
      data = action.payload.data;
      state = {
        ...state,
        actives: data.actives,
        status: 'TRACKERS_ACTIVES_INIT'
      };
      break;
    case 'TRACKERS_TOUR_START':
      data = action.payload.data;
      state = __trackers_tour_start(state, data.id, data.info);
      break;
    case 'TRACKERS_TOUR_END':
      data = action.payload.data;
      state = __trackers_tour_end(state, data);
      break;
    case 'TRACKERS_TOUR_ROUTE':
      data = action.payload.data;
      state = __trackers_tour_route(state, data);
      break;
    case 'TRACKERS_PANIC_START':
      data = action.payload.data;
      state = __trackers_panic_start(state, data);
      break;
    case 'TRACKERS_PANIC_STOP':
      data = action.payload.data;
      state = __trackers_panic_stop(state, data);
      break;
    case 'TRACKERS_TOUR_VISITED':
      data = action.payload.data;
      state = __trackers_tour_visited(state, data);
      break;
    default:
      return state;
  }
  return state;
}

function defaultState() {
  return {
    status: '',
    error: null,
    actives: {
      byid: {},
      list: []
    }
  };
}

/** Update trackers.actives.byid[id] and trackers.actives.list
 * 
 * @param {original state} state 
 * @param {unique id of tracker} trackerId 
 * @param {newly activated tracker} tracker
 */
function __trackers_tour_start(state, trackerId, tracker) {
  let { actives, ..._state } = state;
  let { byid, list, ..._actives } = actives;

  if (
    list.find(id => {
      return id === trackerId;
    })
  ) {
    return state;
  }

  let _byid = { ...byid, ...tracker.byid };
  let _list = [...list, ...tracker.list];

  _actives = { ..._actives, byid: _byid, list: _list };
  _state = { ..._state, actives: _actives };

  return _state;
}
function __trackers_tour_end(state, trackerId) {
  const tid = `${trackerId}`;

  let { actives, ..._state } = state;
  let { byid, list, ..._actives } = actives;

  /* eslint-disable no-unused-vars*/
  let { [tid]: rm, ..._byid } = byid;
  /* eslint-enable no-disable-unused-vars*/
  let _list = list.filter(e => e !== trackerId);

  _actives = { ..._actives, byid: _byid, list: _list };
  _state = { ..._state, actives: _actives };

  return _state;
}
function __trackers_tour_route(state, data) {
  const { list } = state.actives;
  if (
    !list.find(e => {
      return e === data.trackerId;
    })
  ) {
    //console.log("__trackers_tour_route > exist : false")
    return state;
  }
  //console.log("__trackers_tour_route > exist : true")
  let _id = `${data.trackerId}`;

  //state.actives.byid.tid.route.byid
  //state.actives.byid.tid.route.list

  let { actives, ..._state } = state;
  let { byid, ..._actives } = actives;
  let { [_id]: tid, ..._byid } = byid;
  let { route, ..._tid } = tid;
  let rbyid = { ...route.byid };
  let rlist = [...route.list];

  rbyid = { ...rbyid, ...data.path };
  rlist = [...rlist, ...data.route[data.trackerId]];

  route = { byid: { ...rbyid }, list: [...rlist] };
  _tid = { ..._tid, route: route };
  _byid = { ..._byid, [_id]: _tid };
  _actives = { ..._actives, byid: _byid };
  _state = { ..._state, actives: _actives };

  //console.log("__trackers_tour_route===============_state:", _state)

  return _state;
}
function __trackers_tour_visited(trackers, data) {
  //upsert to trackers.actives.byid[trackerId].tour.visited.byid[serialNumber].byid[pointId] = data
  //upsert to trackers.actives.byid[trackerId].tour.visited.byid[serialNumber].list = [pointId]
  if (!trackers.actives.byid[data.tracker_id]) {
    return trackers;
  }

  const trackerId = data.tracker_id;
  const point = data.point;

  const _trackerId = `${trackerId}`;

  // let _trackers = {
  //   ...trackers,
  //   actives:{
  //     ...trackers.actives,
  //     byid:{
  //       ...trackers.actives.byid,
  //       [_trackerId]:{
  //         ...trackers.actives.byid[_trackerId],
  //         tour:{
  //           ...trackers.actives.byid[_trackerId].tour,
  //           visited:{
  //             ...trackers.actives.byid[_trackerId].tour.visited,
  //             byid:{
  //               ...trackers.actives.byid[_trackerId].tour.visited.byid,
  //               [point.serialNumber]:{
  //                 ...trackers.actives.byid[_trackerId].tour.visited.byid[point.serialNumber],
  //                 byid:{
  //                   ...trackers.actives.byid[_trackerId].tour.visited.byid[point.serialNumber].byid,
  //                   [point.id]:point
  //                 },
  //                 list: [...trackers.actives.byid[_trackerId].tour.visited.byid[point.serialNumber].list, point.id]
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  let { actives, ..._trackers } = trackers;
  let { byid, ..._actives } = actives;
  let { [_trackerId]: trackerId_, ..._byid } = byid;
  let { tour, ..._trackerId_ } = trackerId_;
  let { visited, ..._tour } = tour;

  let _visited = activesByidIdTourVisited(visited, point);

  _tour = { ..._tour, visited: _visited };
  _trackerId_ = { ..._trackerId_, tour: _tour };
  _byid = { ..._byid, [_trackerId]: _trackerId_ };
  _actives = { ..._actives, byid: _byid };
  _trackers = { ..._trackers, actives: _actives };

  return _trackers;
}
function activesByidIdTourVisited(visited, point) {
  let { byid, list, ..._visited } = visited;

  if (!byid[point.serialNumber]) {
    list = [...list, point.serialNumber];
    byid[point.serialNumber] = {
      byid: {
        [point.id]: point
      },
      list: [point.id]
    }
    _visited['byid'] = byid;
    _visited['list'] = list;
    return _visited;
  }

  let { [point.serialNumber]: serialNumber, ..._byid } = byid;

  if (serialNumber.byid[point.id]) {
    return visited;
  }
  serialNumber.byid[point.id] = point;
  serialNumber.list = [...serialNumber.list, point.id];

  _byid[point.serialNumber] = serialNumber;
  _visited['byid'] = _byid;
  _visited['list'] = list;

  return _visited;
}

function __trackers_panic_start(state, data) {
  //console.log('__trackers_panic_start > data : ', data);
  //console.log("__trackers_panic_start > trackerId : ", data.trackerId)
  //console.log("__trackers_panic_start > actives :", state.actives.list) //--- Returns EMPTY DATA!

  if (
    !state.actives.list.find(i => {
      return i === data.trackerId;
    })
  ) {
    //console.log(`__trackers_panic_start > trackerId : ${data.trackerId} not found`)
    return state;
  }
  //console.log(`__trackers_panic_start > trackerId : ${data.trackerId} found`)

  let trackerId = data.trackerId;
  let _id = `${trackerId}`;
  let info = data.info;

  let { actives, ..._state } = state;
  let { byid, ..._actives } = actives;
  let { [_id]: tid, ..._byid } = byid;
  let { panic, route, ..._tid } = tid;

  panic = { ...panic, ...info.panic[_id] };

  let rbyid = { ...route.byid };
  let rlist = [...route.list];

  rbyid = { ...rbyid, ...info.path };
  rlist = [...rlist, ...info.route[trackerId]];

  route = { byid: { ...rbyid }, list: [...rlist] };
  _tid = { ..._tid, ...info.tracker[_id] };

  _tid = { ..._tid, panic: { ...panic }, route: route };
  _byid = { ..._byid, [_id]: _tid };
  _actives = { ..._actives, byid: _byid };
  _state = { ..._state, actives: _actives };

  return _state;
}

function __trackers_panic_stop(state, trackerId) {
  //console.log("__trackers_panic_stop > trackerId:", trackerId)
  if (
    !state.actives.list.find(i => {
      return i === Number(trackerId);
    })
  ) {
    return state;
  }
  //console.log("__trackers_panic_stop > actives:", state.actives)
  let _id = `${trackerId}`;

  let { actives, ..._state } = state;
  let { byid, list, ..._actives } = actives;

  let { [_id]: tid, ..._byid } = byid;

  if (tid.isPanic) {
    if (!tid.isTour) {
      let _list = list.filter(f => {
        return f !== trackerId;
      });
      _actives = { ..._actives, byid: _byid, list: _list };
      _state = { ..._state, actives: _actives };
      return _state;
    } else {
      tid.isPanic = false;
    }
  }

  let _tid = { ...tid, panic: {} };
  _byid = { ..._byid, [_id]: _tid };
  _actives = { ..._actives, byid: _byid, list: list };
  _state = { ..._state, actives: _actives };
  return _state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/_trackers.js